import { useMemo, useState } from "react";
import { setErrorStatus } from "../../Redux/status/action";
import Button from "../Button/Button";
import { SelectionSquareCard } from "../Cards/Cards";
import PreviewBar from "../PreviewBar/PreviewBar";

function WorkforceSummaryPreview(props) {
  const [formData, setFormData] = useState([]);

  const getDifferentInDays = (value) => {
    const fromDate = new Date(value.from);
    const toDate = new Date(value.to);
    const diffInMs = toDate - fromDate;
    return diffInMs / (1000 * 60 * 60 * 24);
  };

  const handleDisable = useMemo(() => {
    const dateRange = props.appliedFilters.dateRange;

    if (!dateRange) {
      return true;
    }
    if (dateRange.type === "Lifetime") {
      return true;
    }

    return getDifferentInDays(dateRange) > 31;
  }, [props.appliedFilters.dateRange]);

  const exportOptions = [
    {
      title: "Employee profile",
      description:
        "Export a list of employees with their profiles and role information.",
      disabled: false
    },
    {
      title: "Face capture",
      description:
        "Export records of facial captures used for attendance and identification.",
      disabled: handleDisable
    },
    {
      title: "Attendance log",
      description:
        "Export detailed attendance logs, including timestamps and statuses.",
      disabled: handleDisable
    }
  ];

  return (
    <>
      <PreviewBar
        title={
          <div className="display-flex flex-align-items-center">
            <div className="font-color-tertiaryColor font-size-larger">
              Download summary
            </div>
            <div
              style={{
                color: "var(--secondaryColor)"
              }}
              className="padding-left-default font-size-small text-uppercase"
            >
              {props.data?.type}
            </div>
          </div>
        }
        description={props.data?.email || props.data?.phoneNumber}
        onCloseClick={() => {
          props.navigate("/workforce");
        }}
      >
        <div className="inherit-parent-height">
          <div className="display-flex flex-direction-column flex-justify-content-space-between inherit-parent-height">
            <div>
              <div className="padding-bottom-large font-color-tertiaryColor6">
                EXPORT OPTIONS
              </div>
              {exportOptions.map((data, i) => (
                <div
                  title={
                    data.disabled ? "Date range filter exceeds 30 days" : false
                  }
                  style={{
                    cursor: data.disabled ? "not-allowed" : "pointer",
                    opacity: data.disabled ? 0.5 : 1
                  }}
                  key={i}
                  onClick={() => {
                    if (data.disabled) {
                      return setErrorStatus({
                        code: "custom",
                        message: "Date range filter exceeds 30 days"
                      });
                    }

                    if (formData.includes(data.title?.toLocaleLowerCase())) {
                      setFormData(
                        formData.filter(
                          (item) => item !== data.title?.toLocaleLowerCase()
                        )
                      );
                    } else {
                      setFormData([
                        ...formData,
                        data.title.toLocaleLowerCase()
                      ]);
                    }
                  }}
                  className="padding-bottom-large"
                >
                  <SelectionSquareCard
                    data={data}
                    selected={formData.includes(data.title.toLocaleLowerCase())}
                  />
                </div>
              ))}
            </div>
            <div>
              <Button
                type="button"
                data-cy="TYPE-DOWNLOAD-BUTTON"
                loading={props.exportLoading}
                disabled={formData.length > 0 ? false : true}
                text="Download"
                onClick={() => props.summaryDownloadClick(formData)}
              />
            </div>
          </div>
        </div>
      </PreviewBar>
    </>
  );
}

export default WorkforceSummaryPreview;
